import React from "react";
import PropTypes from "prop-types";
import { Divider } from "antd";

import { useSelector } from "react-redux";

const OrientedDivider = (props) => {
  const { message } = props;
  const currentAppLocale = useSelector((state) => state.user.currentAppLocale);
  const direction = currentAppLocale.direction;
  const orientation = direction === "rtl" ? "right" : "left";
  return <Divider orientation={orientation}>{message}</Divider>;
};

OrientedDivider.propTypes = {
  message: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default OrientedDivider;
